import { render, staticRenderFns } from "./IconTie.vue?vue&type=template&id=2d10b2c8"
import script from "./IconTie.vue?vue&type=script&lang=js"
export * from "./IconTie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports